import React from 'react';

const DeletePrescriptionPopup = ({ show, onClose, onConfirm, prescriptionName }) => {
    if (!show) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Delete Prescription</h3>
                <p className="text-gray-700 mb-6">
                    Are you sure you want to delete the prescription file "{prescriptionName}"? This action cannot be undone.
                </p>
                <div className="flex justify-end gap-4">
                    <button 
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-800 rounded hover:bg-gray-200 transition-all duration-200"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-all duration-200"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeletePrescriptionPopup;